import React from "react";
import { BsHouseDoor } from "react-icons/bs";
import { RiServiceLine } from "react-icons/ri";
import { AiOutlineLock, AiOutlinePieChart } from "react-icons/ai";
import {
  FaCity,
  FaUserShield,
  FaPeopleArrows,
  FaPlaceOfWorship,
  FaRobot,
} from "react-icons/fa";
import {
  MdPayment,
  MdOutlineStairs,
  MdAdminPanelSettings,
  MdOutlineBeachAccess,
  MdOutlineBusinessCenter,
  MdSettingsSystemDaydream,
} from "react-icons/md";

import { ROUTES } from "./routes";
import type { MenuGroup, Role } from "./types";

const ALL_ADMINS: Role[] = [
  "admin",
  "super_admin",
  "content_admin",
  "content_creator",
  "company_owner",
  "system_admin",
];

const iconClass = "h-[15px] w-[15px]";

export const MENU_GROUPS: MenuGroup[] = [
  {
    title: "Dashboard",
    category: "Overview",
    icon: <BsHouseDoor className={iconClass} />,
    roles: ALL_ADMINS,
    menu: [
      { title: "Dashboad", ref: ROUTES.home },
      {
        title: "Global Search",
        ref: ROUTES.search,
        roles: ["admin", "super_admin"],
      },
    ],
  },
  {
    title: "My Statistics",
    category: "Overview",
    icon: <AiOutlinePieChart className={iconClass} />,
    roles: ALL_ADMINS,
    menu: [{ title: "My Statistics", ref: ROUTES.contentStats }],
  },
  {
    title: "My Password",
    category: "Overview",
    icon: <AiOutlineLock className={iconClass} />,
    roles: ALL_ADMINS,
    menu: [{ title: "Update Password", ref: ROUTES.password }],
  },
  {
    title: "Regions",
    category: "Locations",
    icon: <FaPlaceOfWorship className={iconClass} />,
    roles: ["admin", "super_admin"],
    menu: [
      { title: "Dashboard", ref: ROUTES.regionDash },
      { title: "Manage", ref: ROUTES.regionSettings },
    ],
  },
  {
    title: "Countries",
    category: "Locations",
    icon: <FaPeopleArrows className={iconClass} />,
    roles: ALL_ADMINS,
    menu: [
      { title: "Dashboard", ref: ROUTES.countriesDash },
      { title: "Manage", ref: ROUTES.countriesSettings },
    ],
  },
  {
    title: "Our Levels",
    category: "Locations",
    icon: <MdOutlineStairs className={iconClass} />,
    roles: ["admin", "super_admin"],
    menu: [
      { title: "Dashboard", ref: ROUTES.levelDash },
      { title: "Manage", ref: ROUTES.levelSettings },
    ],
  },
  {
    title: "Cities",
    category: "Locations",
    icon: <FaCity className={iconClass} />,
    roles: ALL_ADMINS,
    menu: [
      { title: "Dashboard", ref: ROUTES.citiesDasb },
      { title: "Manage", ref: ROUTES.citiesSettings },
    ],
  },
  {
    title: "Pages & Blog",
    category: "Content",
    icon: <RiServiceLine className={iconClass} />,
    roles: ALL_ADMINS,
    menu: [
      { title: "Pages", ref: ROUTES.page },
      { title: "Banner Images", ref: ROUTES.banner },
      { title: "Blog", ref: ROUTES.blog },
    ],
  },
  {
    title: "Additional Data",
    category: "Content",
    icon: <MdOutlineBeachAccess className={iconClass} />,
    roles: ["admin", "super_admin"],
    menu: [
      { title: "Trade Organizations", ref: ROUTES.tradeOrganization },
      { title: "Regional Blocks", ref: ROUTES.regionalBlocks },
      { title: "Plug Images", ref: ROUTES.plugImage },
      { title: "Climates", ref: ROUTES.climate },
      { title: "Ethnic Groups", ref: ROUTES.ethnicGroup },
      { title: "Languages", ref: ROUTES.language },
      { title: "Religions", ref: ROUTES.religion },
    ],
  },
  {
    title: "AI Content Generation",
    category: "Content",
    icon: <FaRobot className={iconClass} />,
    roles: ["super_admin"],
    menu: [
      { title: "Manage", ref: ROUTES.generatedEvents },
      { title: "Chat Support", ref: ROUTES.chatSupport },
    ],
  },
  {
    title: "Edit Sitepages",
    category: "Content",
    icon: <MdSettingsSystemDaydream className={iconClass} />,
    roles: ["admin", "super_admin"],
    menu: [
      { title: "About Us - Settings", ref: ROUTES.about },
      { title: "Footer - Settings", ref: ROUTES.footer },
      { title: "Ai Chat Info - Settings", ref: ROUTES.aiChatInfo },
      { title: "Contact Us Forms - Settings", ref: ROUTES.contact },
      { title: "Email Templates - Settings", ref: ROUTES.email },
      { title: "Our Service - Settings", ref: ROUTES.service },
      { title: "Our Partners - Settings", ref: ROUTES.partner },
      { title: "Terms & Conditions", ref: ROUTES.terms },
      { title: "Privacy Policy", ref: ROUTES.privacy },
    ],
  },
  {
    title: "Users / Agents Settings",
    category: "People",
    icon: <FaUserShield className={iconClass} />,
    roles: ["admin", "super_admin"],
    menu: [
      { title: "Do see - Agents", ref: ROUTES.agent },
      { title: "Do see - Users", ref: ROUTES.user },
      { title: "Do see - Team", ref: ROUTES.team },
    ],
  },
  {
    title: "Admins & Statistics",
    category: "People",
    icon: <MdAdminPanelSettings className={iconClass} />,
    roles: [
      "admin",
      "super_admin",
      "content_admin",
      "company_owner",
      "system_admin",
    ],
    menu: [
      {
        title: "Admins Settings",
        ref: ROUTES.admin,
        roles: ["admin", "super_admin", "company_owner", "system_admin"],
      },
      { title: "Admins Statistics", ref: ROUTES.adminsStats },
    ],
  },
  {
    title: "Company Management",
    category: "People",
    icon: <MdOutlineBusinessCenter className={iconClass} />,
    roles: ["admin", "super_admin", "company_owner"],
    menu: [{ title: "Manage", ref: ROUTES.company }],
  },
  {
    title: "Payments",
    category: "Commerce",
    icon: <MdPayment className={iconClass} />,
    roles: ["admin", "super_admin", "company_owner", "system_admin"],
    menu: [
      {
        title: "Payments - History",
        ref: ROUTES.payment,
        roles: ["admin", "super_admin", "company_owner", "system_admin"],
      },
    ],
  },
  {
    title: "Subscriptions",
    category: "Commerce",
    icon: <MdPayment className={iconClass} />,
    roles: ["admin", "super_admin"],
    menu: [{ title: "Do see - Newsletter", ref: ROUTES.newsletter }],
  },
];
